import {useMemo} from 'react';
import {companySettingsConstants, expensesPlanConstants} from '../constants';
import {useCompanySetting} from './useCompanySetting';

export const useIsAdvancedExpensesPlan = () => {
  const plan = useCompanySetting(companySettingsConstants.EXPENSES_PLAN);

  return useMemo(() => plan === expensesPlanConstants.ADVANCED, [plan]);
};

